const login = {
  state: {
	username:localStorage.getItem('username'),
	newrouter:[],
  },
  mutations: {
    SET_NAME:(state, name) => {
		state.username = name;
	},
	SET_ROLE:(state, role) => {
		state.role = role;
	},
	SET_INTRODUCE:(state, introduce) =>{
		state.introduce = introduce;
	},
	SET_NEWROUER:(state, newrouter) =>{
		state.newrouter = newrouter;
	},
	SET_PORTRAIT:(state, url) => {
		state.portrait = url;
	}
  },
  actions: {
	GetInfo({ commit }) {
		if(Boolean(localStorage.getItem('username')) != false) {
			commit('SET_NAME',localStorage.getItem('username'))
		}
		return localStorage.getItem('token')
	}
  }
}
export default login;